import React, { useState } from 'react';
import { FileTextIcon, CheckCircleIcon, XCircleIcon, ArrowRightIcon, ThumbsUpIcon, ThumbsDownIcon, SearchIcon, EyeIcon, SaveIcon } from 'lucide-react';
// Sample training data
const sampleTrainingDocuments = [{
  id: 'train-001',
  documentType: 'Invoice',
  vendor: 'Office Depot',
  date: '2023-09-15',
  status: 'Needs Review',
  confidence: 0.82,
  fields: [{
    name: 'invoiceNumber',
    expected: 'INV-2023-4501',
    extracted: 'INV-2023-4501',
    correct: true
  }, {
    name: 'invoiceDate',
    expected: '2023-09-15',
    extracted: '2023-09-15',
    correct: true
  }, {
    name: 'vendorName',
    expected: 'Office Depot',
    extracted: 'Office Depot',
    correct: true
  }, {
    name: 'vendorAddress',
    expected: '123 Business Ave, Suite 100, San Francisco, CA 94107',
    extracted: '123 Busines Ave, Suite 100, San Francisco, CA 94107',
    correct: false
  }, {
    name: 'total',
    expected: '1250.75',
    extracted: '1250.75',
    correct: true
  }],
  imageUrl: 'https://templates.invoicehome.com/invoice-template-us-neat-750px.png'
}, {
  id: 'train-002',
  documentType: 'Credit Note',
  vendor: 'Dell Technologies',
  date: '2023-09-10',
  status: 'Needs Review',
  confidence: 0.75,
  fields: [{
    name: 'creditNoteNumber',
    expected: 'CN-2023-102',
    extracted: 'CN-2023-102',
    correct: true
  }, {
    name: 'creditNoteDate',
    expected: '2023-09-10',
    extracted: '2023-09-10',
    correct: true
  }, {
    name: 'vendorName',
    expected: 'Dell Technologies',
    extracted: 'Dell Technoloqies',
    correct: false
  }, {
    name: 'total',
    expected: '430.00',
    extracted: '430.00',
    correct: true
  }, {
    name: 'reason',
    expected: 'Returned Items',
    extracted: 'Retumed Items',
    correct: false
  }],
  imageUrl: 'https://templates.invoicehome.com/invoice-template-us-neat-750px.png'
}, {
  id: 'train-003',
  documentType: 'Invoice',
  vendor: 'PrintWorks Inc.',
  date: '2023-09-05',
  status: 'Reviewed',
  confidence: 0.88,
  fields: [{
    name: 'invoiceNumber',
    expected: 'INV-PW-5782',
    extracted: 'INV-PW-5782',
    correct: true
  }, {
    name: 'invoiceDate',
    expected: '2023-09-05',
    extracted: '2023-09-05',
    correct: true
  }, {
    name: 'vendorName',
    expected: 'PrintWorks Inc.',
    extracted: 'PrintWorks Inc.',
    correct: true
  }, {
    name: 'vendorAddress',
    expected: '456 Print Street, Chicago, IL 60601',
    extracted: '456 Print Street, Chicago, IL 60601',
    correct: true
  }, {
    name: 'total',
    expected: '3200.50',
    extracted: '3200.50',
    correct: true
  }],
  imageUrl: 'https://templates.invoicehome.com/invoice-template-us-neat-750px.png'
}];
export function DITraining({
  locale = 'en-US'
}) {
  const [trainingDocuments, setTrainingDocuments] = useState(sampleTrainingDocuments);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [showingImage, setShowingImage] = useState(false);
  // Filter documents based on search and status filter
  const filteredDocuments = trainingDocuments.filter(doc => {
    const matchesSearch = doc.vendor.toLowerCase().includes(searchTerm.toLowerCase()) || doc.documentType.toLowerCase().includes(searchTerm.toLowerCase()) || doc.id.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'All' || doc.status === statusFilter;
    return matchesSearch && matchesStatus;
  });
  // Handle document selection
  const handleSelectDocument = document => {
    setSelectedDocument(document);
    setShowingImage(false);
  };
  // Handle marking a field as correct
  const handleMarkFieldCorrect = (fieldIndex, isCorrect) => {
    if (!selectedDocument) return;
    const updatedFields = [...selectedDocument.fields];
    updatedFields[fieldIndex] = {
      ...updatedFields[fieldIndex],
      correct: isCorrect
    };
    const updatedDocument = {
      ...selectedDocument,
      fields: updatedFields
    };
    setSelectedDocument(updatedDocument);
    // Update the document in the list
    setTrainingDocuments(trainingDocuments.map(doc => doc.id === selectedDocument.id ? updatedDocument : doc));
  };
  // Handle saving training results
  const handleSaveTraining = () => {
    if (!selectedDocument) return;
    // In a real app, this would send the training data to an API
    const updatedDocuments = trainingDocuments.map(doc => doc.id === selectedDocument.id ? {
      ...selectedDocument,
      status: 'Reviewed'
    } : doc);
    setTrainingDocuments(updatedDocuments);
    setSelectedDocument({
      ...selectedDocument,
      status: 'Reviewed'
    });
    alert('Training data saved successfully');
  };
  // Toggle between document details and image view
  const toggleImageView = () => {
    setShowingImage(!showingImage);
  };
  return <div className="mb-8" data-id="element-4363">
      <div className="flex justify-between items-center mb-6" data-id="element-4364">
        <div data-id="element-4365">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-4366">DI Training</h2>
          <p className="mt-1 text-sm text-gray-500" data-id="element-4367">
            Review and correct Document Intelligence results to improve
            extraction accuracy
          </p>
        </div>
      </div>
      {/* Filters */}
      <div className="bg-white shadow overflow-hidden sm:rounded-lg mb-6" data-id="element-4368">
        <div className="px-4 py-5 sm:p-6" data-id="element-4369">
          <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-4370">
            <div className="sm:col-span-3" data-id="element-4371">
              <label htmlFor="search" className="block text-sm font-medium text-gray-700" data-id="element-4372">
                Search
              </label>
              <div className="mt-1 relative rounded-md shadow-sm" data-id="element-4373">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-4374">
                  <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-4375" />
                </div>
                <input type="text" name="search" id="search" className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md" placeholder="Search by vendor or document type" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-4376" />
              </div>
            </div>
            <div className="sm:col-span-3" data-id="element-4377">
              <label htmlFor="status-filter" className="block text-sm font-medium text-gray-700" data-id="element-4378">
                Status
              </label>
              <select id="status-filter" name="status-filter" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-4379">
                <option value="All" data-id="element-4380">All</option>
                <option value="Needs Review" data-id="element-4381">Needs Review</option>
                <option value="Reviewed" data-id="element-4382">Reviewed</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-4383">
        {/* Documents List */}
        <div className="lg:col-span-1" data-id="element-4384">
          <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-4385">
            <div className="px-4 py-5 border-b border-gray-200 sm:px-6" data-id="element-4386">
              <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-4387">
                Training Documents
              </h3>
            </div>
            {filteredDocuments.length === 0 ? <div className="px-4 py-5 sm:p-6 text-center" data-id="element-4388">
                <p className="text-gray-500" data-id="element-4389">No documents match your filters</p>
              </div> : <ul className="divide-y divide-gray-200" data-id="element-4390">
                {filteredDocuments.map(document => <li key={document.id} className={`px-4 py-4 hover:bg-gray-50 cursor-pointer ${selectedDocument?.id === document.id ? 'bg-indigo-50' : ''}`} onClick={() => handleSelectDocument(document)} data-id="element-4391">
                    <div className="flex items-center justify-between" data-id="element-4392">
                      <div className="flex items-center" data-id="element-4393">
                        <FileTextIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-4394" />
                        <span className="text-sm font-medium text-gray-900" data-id="element-4395">
                          {document.vendor}
                        </span>
                      </div>
                      <div className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${document.status === 'Reviewed' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-4396">
                        {document.status}
                      </div>
                    </div>
                    <div className="mt-2 flex justify-between" data-id="element-4397">
                      <div className="text-sm text-gray-500" data-id="element-4398">
                        {document.documentType} • {document.date}
                      </div>
                      <div className="text-sm text-gray-500" data-id="element-4399">
                        {Math.round(document.confidence * 100)}% accurate
                      </div>
                    </div>
                  </li>)}
              </ul>}
          </div>
        </div>
        {/* Document Details */}
        <div className="lg:col-span-2" data-id="element-4400">
          {selectedDocument ? <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-4401">
              <div className="px-4 py-5 border-b border-gray-200 sm:px-6" data-id="element-4402">
                <div className="flex justify-between items-center" data-id="element-4403">
                  <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-4404">
                    {showingImage ? 'Document Image' : 'Field Comparison'}
                  </h3>
                  <button type="button" onClick={toggleImageView} className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-4405">
                    <EyeIcon className="h-4 w-4 mr-1" data-id="element-4406" />
                    {showingImage ? 'Show Fields' : 'Show Image'}
                  </button>
                </div>
              </div>
              {showingImage ? <div className="p-4 flex justify-center" data-id="element-4407">
                  <img src={selectedDocument.imageUrl} alt="Document" className="max-w-full h-auto shadow-md" data-id="element-4408" />
                </div> : <div className="px-4 py-5 sm:p-6" data-id="element-4409">
                  <div className="mb-4" data-id="element-4410">
                    <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-4411">
                      Document Information
                    </h4>
                    <dl className="grid grid-cols-2 gap-4" data-id="element-4412">
                      <div data-id="element-4413">
                        <dt className="text-sm font-medium text-gray-500" data-id="element-4414">
                          Document Type
                        </dt>
                        <dd className="mt-1 text-sm text-gray-900" data-id="element-4415">
                          {selectedDocument.documentType}
                        </dd>
                      </div>
                      <div data-id="element-4416">
                        <dt className="text-sm font-medium text-gray-500" data-id="element-4417">
                          Vendor
                        </dt>
                        <dd className="mt-1 text-sm text-gray-900" data-id="element-4418">
                          {selectedDocument.vendor}
                        </dd>
                      </div>
                      <div data-id="element-4419">
                        <dt className="text-sm font-medium text-gray-500" data-id="element-4420">
                          Date
                        </dt>
                        <dd className="mt-1 text-sm text-gray-900" data-id="element-4421">
                          {selectedDocument.date}
                        </dd>
                      </div>
                      <div data-id="element-4422">
                        <dt className="text-sm font-medium text-gray-500" data-id="element-4423">
                          Confidence
                        </dt>
                        <dd className="mt-1 text-sm text-gray-900" data-id="element-4424">
                          {Math.round(selectedDocument.confidence * 100)}%
                        </dd>
                      </div>
                    </dl>
                  </div>
                  <div className="mt-6" data-id="element-4425">
                    <h4 className="text-sm font-medium text-gray-900 mb-4" data-id="element-4426">
                      Field Comparison
                    </h4>
                    <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg" data-id="element-4427">
                      <table className="min-w-full divide-y divide-gray-300" data-id="element-4428">
                        <thead className="bg-gray-50" data-id="element-4429">
                          <tr data-id="element-4430">
                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6" data-id="element-4431">
                              Field
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-4432">
                              Expected
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-4433">
                              Extracted
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-4434">
                              Status
                            </th>
                            <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6" data-id="element-4435">
                              <span className="sr-only" data-id="element-4436">Actions</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 bg-white" data-id="element-4437">
                          {selectedDocument.fields.map((field, index) => <tr key={field.name} className={field.correct ? '' : 'bg-red-50'} data-id="element-4438">
                              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" data-id="element-4439">
                                {field.name}
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" data-id="element-4440">
                                {field.expected}
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" data-id="element-4441">
                                {field.extracted}
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm" data-id="element-4442">
                                {field.correct ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-4443">
                                    <CheckCircleIcon className="h-4 w-4 mr-1" data-id="element-4444" />
                                    Correct
                                  </span> : <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-4445">
                                    <XCircleIcon className="h-4 w-4 mr-1" data-id="element-4446" />
                                    Incorrect
                                  </span>}
                              </td>
                              <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6" data-id="element-4447">
                                <div className="flex space-x-2 justify-end" data-id="element-4448">
                                  <button type="button" onClick={() => handleMarkFieldCorrect(index, true)} className={`text-green-600 hover:text-green-900 ${field.correct ? 'opacity-50 cursor-not-allowed' : ''}`} disabled={field.correct} data-id="element-4449">
                                    <ThumbsUpIcon className="h-4 w-4" data-id="element-4450" />
                                  </button>
                                  <button type="button" onClick={() => handleMarkFieldCorrect(index, false)} className={`text-red-600 hover:text-red-900 ${!field.correct ? 'opacity-50 cursor-not-allowed' : ''}`} disabled={!field.correct} data-id="element-4451">
                                    <ThumbsDownIcon className="h-4 w-4" data-id="element-4452" />
                                  </button>
                                </div>
                              </td>
                            </tr>)}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="mt-6 flex justify-end" data-id="element-4453">
                    <button type="button" onClick={handleSaveTraining} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" disabled={selectedDocument.status === 'Reviewed'} data-id="element-4454">
                      <SaveIcon className="h-4 w-4 mr-2" data-id="element-4455" />
                      Save Training
                    </button>
                  </div>
                </div>}
            </div> : <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-4456">
              <div className="px-4 py-5 sm:p-6 text-center" data-id="element-4457">
                <FileTextIcon className="mx-auto h-12 w-12 text-gray-400" data-id="element-4458" />
                <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-4459">
                  No document selected
                </h3>
                <p className="mt-1 text-sm text-gray-500" data-id="element-4460">
                  Select a document from the list to review and train Document
                  Intelligence results
                </p>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}